<template>
    <div class="item">
        <div class="description">
            <img class="image" :src="image"/>
            <div class="name">{{ item.name }}</div>
        </div>
        <v-dialog v-model="dialog" persistent max-width="600px">
            <!-- Кнопка вызова диалогового окна -->

            <!-- Форма создания комплектубщей -->
            <v-card>
                <v-card-title>
                    <span class="headline">История изменений</span>
                </v-card-title>

                <v-card-text>
                    <v-container>
                        <div class="log" v-for="log in logs" :key="log._id">
                            <div class="date">{{ formated_date(log.date) }}</div>
                            <template v-if="log.quantity <= 0">
                                <div class="quantity quantity--red">-{{ log.quantity }}</div>
                            </template>
                            <template v-else>
                                <div class="quantity quantity--green">+{{ log.quantity }}</div>
                            </template>
                        </div>
                    </v-container>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="dialog = false">Закрыть</v-btn>
                </v-card-actions>
                
            </v-card>
        </v-dialog>
        <template v-if="fact">
            <div class="inputs">
                <div class="input">
                    <div class="input-group">
                        <v-text-field label="Факт" :disabled="status == 'close'" v-model="fact_quantity" type="number"></v-text-field>
                        <v-btn
                            class="ml-4"
                            small
                            fab
                            :dark="status == 'open'"
                            color="warning"
                            :disabled="status == 'close'"
                            @click="set_fact(item)"
                        ><v-icon dark>mdi-plus</v-icon></v-btn>
                        <v-btn class="ml-4" small @click="open_logs(item)"><v-icon dark>mdi-format-list-bulleted-square</v-icon></v-btn>
                    </div>
                </div>

                <div class="input d-flex">
                    <v-text-field label="План" disabled v-model="item.fact"></v-text-field>
                    <v-text-field disabled value="/"></v-text-field>
                    <v-text-field disabled v-model="item.plan"></v-text-field>
                </div>
            </div>
        </template>
        <template v-if="small">
            <div class="inputs">
                <div class="input">
                    <div class="input-group">
                        <template v-if="item.fact >= item.plan">
                            <v-text-field
                                label="Факт"
                                :value="item.fact"
                                class="v-text-field--green"
                                :disabled="input"
                            ></v-text-field>
                        </template>
                        <template v-else>
                                <v-text-field
                                    label="Факт"
                                    :value="item.fact"
                                    class="v-text-field--red"
                                    :disabled="input"
                                ></v-text-field>
                        </template>
                        <v-btn class="ml-4" small @click="open_logs(item)"><v-icon dark>mdi-format-list-bulleted-square</v-icon></v-btn>
                    </div>
                </div>
                <div class="input">
                  <v-text-field
                      label="План"
                      disabled
                      :value="item.plan"
                      class="v-text-field--green"
                  ></v-text-field>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "AccessoryView",
  data: () => ({
    fact_quantity: 0,
    dialog: false,
    logs: [],
    numberRule: (v) => {
      v = parseInt(v);
      if (v == 0) return "Не может быть нулем";
      return true;
    },
  }),
  props: [
    "item",
    "type",
    "plan",
    "group_id",
    "fact",
    "current_product_id",
    "small",
    "status",
    "_id",
    'input',
      'brigade_count_users',
      'brigade_selected'

  ],
  computed: {
    image() {
        return `/images/accessories/${this.item.image}`;
    },
  },
  methods: {
    ...mapActions(["set_fact_by_accessorry"]),
    open_logs(item) {
        this.logs = item.logs;
        this.dialog = true;
    },
    formated_date(date) {
        return new Date(date).toLocaleDateString("ru-RU", {
            year: "numeric",
            month: "long",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
        });
    },
    set_fact(item) {
        if (this.fact_quantity == 0) {
            return false;
        }

        const accessory = {
            current_date: this.get_current_date,
            product_id: this.current_product_id,
            accessory_id: item._id,
            fact: this.fact_quantity,
            group_id: this.group_id,
            _id: this._id,
            brigade_selected : this.brigade_selected,
        };

        this.set_fact_by_accessorry(accessory)
            .then(() => {
                this.fact_quantity = 0;
            })
            .catch((err) => {
                console.log(err);
            });
    },
  },
};
</script>

<style scoped>
.item {
  color: rgba(0, 0, 0, 0.6);
  background-color: #fff;
  box-shadow: 0 3px 1px -2px rgb(0 0 0 / 20%), 0 2px 2px 0 rgb(0 0 0 / 14%),
    0 1px 5px 0 rgb(0 0 0 / 12%);
  border-radius: 4px;
  font: 15px/24px "Open Sans", Arial, sans-serif;
  padding: 16px;
  display: flex;
  align-items: center;
}

.image {
  object-fit: contain;
  width: 160px;
  height: 160px;
}

.name {
  font-size: 0.933em;
  line-height: 1.501em;
  text-transform: uppercase;
  transition: color ease-out 20ms;
  color: #333;
}

.name:hover {
  color: #f26213;
}

.x {
  font-size: 20px;
  margin: 0 8px;
}

.v-text-field >>> input {
  font-size: 32px;
  width: 100px;
  text-align: center;
}

.input-group {
  display: flex;
  align-items: center;
}

.item.small .description {
  margin-right: 6px;
}

.item.small .image {
  width: 100px;
  height: 100px;
}

.item.small .name {
  font-size: 20px;
}

.item.small .v-text-field >>> input {
  font-size: 26px;
  width: 80px;
  text-align: center;
}

.item.small .v-text-field--green >>> input {
  color: green;
}

.item.small .v-text-field--red >>> input {
  color: red;
}

.log {
  border-bottom: 1px solid #000;
  color: rgba(0, 0, 0, 0.87);
  font-size: 32px;
  display: flex;
  padding: 20px;
}

.log .date {
  color: rgba(0, 0, 0, 0.6);
  font-size: 16px;
  width: 50%;
}

.log .quantity {
  font-size: 32px;
  text-align: left;
  width: 50%;
}

.log .quantity.quantity--green {
  color: green;
}

.log .quantity.quantity--red {
  color: red;
}
</style>